export default __webpack_public_path__ + "assets/moon-waning-gibbous.cd28ac6e.svg";